export default {
  methods: {
    $_showAreYouSureModal() {
      return this.$bvModal.msgBoxConfirm(this.$t('generals.are_you_sure_to_delete'), {
        title: this.$t('generals.please_confirm'),
        size: 'sm',
        // buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('generals.ok'),
        cancelTitle: this.$t('generals.no'),
        // footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
    },
    $_showCustomModal(title, content) {
      return this.$bvModal.msgBoxConfirm(content, {
        title,
        size: 'sm',
        // buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('generals.ok'),
        cancelTitle: this.$t('generals.no'),
        // footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnBackdrop: true,
      })
    },
  },
}
